import { render, staticRenderFns } from "./ArticleHistorySidebar.vue?vue&type=template&id=99baa28c&"
import script from "./ArticleHistorySidebar.vue?vue&type=script&lang=js&"
export * from "./ArticleHistorySidebar.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHistorySidebar.vue?vue&type=style&index=0&id=99baa28c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports